import { render, staticRenderFns } from "./ArtworkColors.vue?vue&type=template&id=33a27d54&"
import script from "./ArtworkColors.vue?vue&type=script&lang=js&"
export * from "./ArtworkColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports